import React, { useEffect, useState } from 'react';

const PageAnimation = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Utiliser requestAnimationFrame pour démarrer l'animation au prochain frame
    // Cela évite le flash en synchronisant avec le rendu du navigateur
    const frame1 = requestAnimationFrame(() => {
      const frame2 = requestAnimationFrame(() => {
        setIsVisible(true);
      });
      return () => cancelAnimationFrame(frame2);
    });

    return () => cancelAnimationFrame(frame1);
  }, []);

  return (
    <div
      className={`w-full transition-all duration-500 ease-out ${
        isVisible
          ? 'opacity-100 translate-y-0'
          : 'opacity-0 translate-y-4'
      }`}
      style={{ 
        willChange: 'opacity, transform',
        backgroundColor: 'transparent'
      }}
    >
      {children}
    </div>
  );
};

export default PageAnimation;

